import React, { useState } from 'react'
import type { InboxFeedItem } from '../../types/inbox'
import { InboxTasksPanel } from './InboxTasksPanel'
import { InboxTeamDiscussPanel } from './InboxTeamDiscussPanel'

type SidebarTab = 'tasks' | 'team'

interface InboxDetailSidebarProps {
  sourceItem: InboxFeedItem
  currentUserId: string | null
  currentUserRole: string | null
  assigneeDefaultId: string | null
  /** @deprecated Notes replaced by Team discuss — kept for call-site compat */
  authorName?: string | null
  onNotesChanged?: () => void
  onTasksChanged?: () => void
}

/** Right sidebar: Tasks + Team discuss tabs beside message thread. */
export function InboxDetailSidebar({
  sourceItem,
  currentUserId,
  currentUserRole,
  assigneeDefaultId,
  onTasksChanged,
}: InboxDetailSidebarProps) {
  const [tab, setTab] = useState<SidebarTab>('tasks')

  return (
    <aside className="flex flex-col w-full lg:w-[320px] lg:max-w-[320px] shrink-0 overflow-hidden border-l border-gray-200 bg-white min-h-0 self-stretch h-56 lg:h-full">
      <div className="flex-shrink-0 flex border-b border-gray-200 min-w-0">
        <button
          type="button"
          onClick={() => setTab('tasks')}
          className={`flex-1 min-w-0 px-2 py-1.5 text-xs font-semibold transition-colors truncate ${
            tab === 'tasks' ? 'text-blue-700 border-b-2 border-blue-600 bg-blue-50/50' : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          Tasks
        </button>
        <button
          type="button"
          onClick={() => setTab('team')}
          className={`flex-1 min-w-0 px-2 py-1.5 text-xs font-semibold transition-colors truncate ${
            tab === 'team' ? 'text-blue-700 border-b-2 border-blue-600 bg-blue-50/50' : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          Team
        </button>
      </div>
      <div className="flex-1 min-w-0 min-h-0 flex flex-col overflow-hidden">
        {tab === 'tasks' ? (
          <InboxTasksPanel
            embedded
            sourceItem={sourceItem}
            currentUserId={currentUserId}
            currentUserRole={currentUserRole}
            assigneeDefaultId={assigneeDefaultId}
            onTasksChanged={onTasksChanged}
          />
        ) : (
          <InboxTeamDiscussPanel itemType={sourceItem.itemType} itemId={sourceItem.id} />
        )}
      </div>
    </aside>
  )
}
